export default "__VITE_ASSET__m05SmeAF__"